<template>
  <GlobalWindow
      :title="title"
      :visible.sync="visible"
      :confirm-working="isWorking"
      @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!--      <el-form-item v-if="parentData != null" label="上级模块" prop="name">-->
      <!--        <el-input :value="parentData.name" :disabled="true" v-trim/>-->
      <!--      </el-form-item>-->
      <el-form-item label="模块名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入模块名称" v-trim @input="handleNameInput"/>
      </el-form-item>
      <el-form-item label="模块英文名称" prop="enName" required>
        <el-input v-model="form.enName" placeholder="请输入模块英文名称" v-trim/>
      </el-form-item>
      <el-form-item label="所属行业" prop="initIndustry">
        <el-input v-model="form.initIndustry" placeholder="请输入所属行业" v-trim/>
      </el-form-item>
      <el-form-item label="是否为模块目录" prop="isDirectory" required>
        <el-switch v-model="form.isDirectory" @change="handleIsDirectoryChange"></el-switch>
      </el-form-item>
      <el-form-item v-if="!form.isDirectory" prop="withEncrypt" label="是否加密" required>
        <el-switch v-model="form.withEncrypt"></el-switch>
      </el-form-item>
      <el-form-item v-if="!form.isDirectory && parentData != null" prop="fixed" label="是否为固定模块" required>
        <el-switch v-model="form.fixed"></el-switch>
      </el-form-item>
      <el-form-item v-if="!form.isDirectory" label="展现形式" prop="viewConfig" required>
        <ViewTypeSelect v-model="form.viewConfig"/>
      </el-form-item>
      <el-form-item v-if="!form.isDirectory" label="模块描述" prop="description">
        <el-input class="description-input" type="textarea" v-model="form.description" placeholder="请输入模块描述" v-trim/>
      </el-form-item>
      <el-form-item v-if="!form.isDirectory" label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入备注" maxlength="500" show-word-limit v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { updateById, create } from '@/api/module/management'
import { pinyin } from 'pinyin-pro'
import ViewTypeSelect from '../common/ViewTypeSelect'

export default {
  name: 'OperaTemplateWindow',
  extends: BaseOpera,
  components: {ViewTypeSelect, GlobalWindow },
  data () {
    const _this = this
    return {
      // 上级的数据
      parentData: null,
      // 上级模块的索引（用于查找第几行）
      parentIndex: -1,
      // 当前这条数据
      targetData: null,
      // 表单数据
      form: {
        id: null,
        // 英文名称
        enName: '',
        // 模块名称
        name: '',
        // 初始行业
        initIndustry: '',
        // 备注
        remark: '',
        // 所属模块
        parentId: null,
        // 模块描述
        description: '',
        // 展现形式
        viewConfig: [],
        // 是否加密
        withEncrypt: false,
        // 是否固定
        fixed: false,
        // 是否为目录
        isDirectory: false
      },
      // 验证规则
      rules: {
        enName: [
          { required: true, message: '请输入模块英文名称' },
          { validator: _this.checkEnName }
        ],
        name: [
          { required: true, message: '请输入模块名称' }
        ],
        viewConfig: [
          { required: true, message: '请选择支持的展现形式' }
        ]
      }
    }
  },
  methods: {
    handleNameInput (value) {
      this.form.enName = pinyin(value, { toneType: 'none', type: 'array' }).map(item => item.substr(0,1)).join('')
    },
    // 切换是否为目录
    handleIsDirectoryChange (value) {
      if (value) {
        this.form.withEncrypt = null
        this.form.fixed = null
      } else {
        this.form.withEncrypt = false
        this.form.fixed = true
      }
    },
    // 验证模块英文名称
    checkEnName (rule, value, callback) {
      if (value.length < 3) {
        callback(new Error('英文名称必须大于2个字符'))
        return
      }
      if (!/^[a-z]+[a-z0-9_]+$/.test(value)) {
        callback(new Error('英文名称必须为小写字母，特殊字符仅允许使用"_"，且不能以"_"和数字开头'))
        return
      }
      callback()
    },
    /**
     * 打开窗口
     *
     * @param title: 窗口标题
     * @param target: 行对象（仅编辑需该参数）
     * @param parent: 新建时的上级模块
     */
    open (title, target, parent) {
      this.title = title
      this.visible = true
      this.parentData = parent == null ? (target == null || target.parentId == null ? null : { id: target.parentId }) : null
      // 新建，menu为空时表示新建菜单
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form.id = null
          this.form.parentId = parent == null ? null : parent.id
          this.form.initIndustry = parent == null ? '' : parent.initIndustry
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        const viewConfig = this.form.viewConfig
        if (viewConfig != null && viewConfig !== '') {
          this.form.viewConfig = JSON.parse(viewConfig)
        }
      })
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      const form = {
        ...this.form,
        viewConfig: JSON.stringify(this.form.viewConfig)
      }
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate(form)
        return
      }
      this.__confirmEdit(form)
    }
  },
  created () {
    this.config({
      api: '/module/management',
      'field.id': 'id'
    })
  }
}
</script>

<style scoped lang="scss">
.el-form {
  /deep/ .description-input {
    .el-textarea__inner {
      height: 120px;
    }
  }
}
</style>
